import { Link } from "react-router";
import { ContributorProfile, Profile } from "@app/types/Cue";
import { getProfilesAlternativePath } from "@pages/Author/utils/helpers";
import { cn } from "@util/helpers";

export type BylineNameProps = {
  profile: Profile | ContributorProfile;
  separator: "," | "&" | "";
  rootClassName?: string;
  linkClassName?: string;
  linkParams?: URLSearchParams;
};

export default function BylineName({
  profile,
  separator,
  rootClassName,
  linkClassName,
  linkParams,
}: BylineNameProps): React.ReactElement {
  const authorName = profile.content.fields.name;
  const alternativePath = getProfilesAlternativePath(
    profile.content.urlPath?.replace("/authors/", "")
  );
  const urlPath = alternativePath || profile.content.urlPath;
  const params = linkParams ? `?${linkParams?.toString()}` : "";

  return (
    <h4 className={cn(rootClassName)} data-testid="byline-name-component">
      {urlPath ? (
        <Link
          to={`${urlPath}${params}`}
          className={cn("!text-gray-850 hover:underline", linkClassName)}
          target="_blank"
          reloadDocument
        >
          {authorName} {separator}
        </Link>
      ) : (
        <>
          {authorName} {separator}
        </>
      )}
    </h4>
  );
}
